import http from "@/http";
//### 供应商列表
// addUserGroupAll
// https://zs.xzu.ink/api/category/list
export const getCategory = {
  p: "/api/category/list",
  r: data => {
    return http({
      url: "/api/category/list",
      method: "post",
      data
    });
  }
};
//### 供应商详细信息
// https://zs.xzu.ink/api/category/details/1036
export const getCategoryInfo = {
  p: "/api/category/details",
  r: data => {
    return http({
      url: "/api/category/details/" + data.id,
      method: "get"
      // data
    });
  }
};
// ### 添加供应商
// https://zs.xzu.ink/api/category/add
export const addCategory = {
  p: "/api/category/add",
  r: data => {
    return http({
      url: "/api/category/add",
      method: "post",
      data
    });
  }
};
//  ### 修改供应商
// https://zs.xzu.ink/api/category/update
export const editCategory = {
  p: "/api/category/update",
  r: data => {
    return http({
      url: "/api/category/update",
      method: "post",
      data
    });
  }
};
//  ### 删除供应商
// https://zs.xzu.ink/api/category/delete
export const deleteCategory = {
  p: "/api/category/delete",
  r: data => {
    return http({
      url: "/api/category/delete",
      method: "post",
      data
    });
  }
};
//  ### 获取供应商select选项
export const addCategoryselects = {
  p: "/api/category/all",
  r: data => {
    return http({
      url: "/api/category/selects",
      method: "get",
      data
    });
  }
};
